import React from 'react';

//import { Helmet } from 'react-helmet';

import webapi from '../../../api/webapi';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

import TopBooks from './TopBooks';

import Parsig01 from '../../images/icon1.jpg'
import Parsig02 from '../../images/icon2.jpg'
import Parsig04 from '../../images/icon4.jpg'
import Parsig03 from '../../images/icon3.jpg'
import Parsig1jpg from '../../images/1.jpg'
import fig9 from '../../images/Footer Logo 1.png'
import fig10 from '../../images/Footer Logo 2.png'
import fig11 from '../../images/Footer Logo 3.png'
import fig12 from '../../images/Footer Logo 4.png'
//import Parsigpazhouheshgahpng from '../../images/22.jpg'
//import jpeg2 from '../../images/23.jpg'
//import Parsigashajpeg from '../../images/asha.jpg'
//import Parsigsandoughpng from '../../images/sandough.png'

// import OwlCarousel from 'react-owl-carousel2';
// import '../../css/owl.theme.default.css';
// import '../../css/owl.style.css';
 
import '../../css/style.css';

//import LoadingGif from '../../images/loading.gif';

// import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
// import { Carousel } from 'react-responsive-carousel';

class Home extends React.Component {
    state = { statments: [] }
    state = { LanguageInfo: [{Code:"Fa",Title:"فارسی",Direction:"rtl"}] }

    constructor(props, context) {
        super(props, context);
        this.state = {
            pageData: undefined
        };
    }

    
    componentDidMount() {
        if (new URLSearchParams(this.props.location.search).get("lang")!=null)
        {
            //console.log('LangFromURL: ',new URLSearchParams(this.props.location.search).get("lang"));
            //console.log('LangFromSubDomain: ',window.location.host.split(".")[0]);
            this.getLanguageInfo(new URLSearchParams(this.props.location.search).get("lang"));
            //console.log(this.state.LanguageInfo);
        }else{
            this.setState({LanguageInfo: [{Code:"Fa",Title:"فارسی",Direction:"rtl"}]});
            document.getElementsByTagName('html')[0].setAttribute("lang","Fa");
            document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
            this.getPage();
        }

        

        //fetch('https://api.ipify.org/?format=json')
        fetch('https://geolocation-db.com/json/')
            .then(response => {
                return response.json();
            }, "jsonp")
            .then(res => {
                this.setLog('pages/log/home/visit/'+res.IPv4.replaceAll('.',','))
            })
            .catch(err => this.setLog('pages/log/home/visit/'+err));
    }

    // componentDidUpdate(){
    //     console.log('update: '+document.documentElement.lang);
    // }

    async setLog(Data) {
        await webapi.post(Data);
    }

    async getLanguageInfo(LanguageCode){
        const responseResultlanguageinfo = await webapi.get('pages/LanguageInfo/'+LanguageCode);
        //console.log(responseResultlanguageinfo.data.length);
        //console.log(responseResultlanguageinfo.data);
        
        if (responseResultlanguageinfo!==undefined && responseResultlanguageinfo.data.length>0)
        {
            this.setState({LanguageInfo:responseResultlanguageinfo.data});
            //this.setState({lang : responseResultlanguageinfo.data[0].Code});
            document.getElementsByTagName('html')[0].setAttribute("lang", responseResultlanguageinfo.data[0].Code);
            document.getElementsByTagName('html')[0].setAttribute("dir", responseResultlanguageinfo.data[0].Direction);
        }
        else
        {
            this.setState({LanguageInfo: [{Code:"Fa",Title:"فارسی",Direction:"rtl"}]});
            //this.setState({lang : responseResultlanguageinfo.data[0].Code});
            document.getElementsByTagName('html')[0].setAttribute("lang","fa");
            document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
        }
        this.getPage();
    }

    async getPage() {
        if (this.state.LanguageInfo)
        {
            const pageList = await webapi.get('pages/datapages/1/'+this.state.LanguageInfo[0].Code);
            //console.log(pageList);
            this.setState({
                pageData: pageList.data
            });
        }else{
            const pageList = await webapi.get('pages/datapages/1/fa');
            //console.log(pageList);
            this.setState({
                pageData: pageList.data
            });
        }

        const TopBooksConst = await webapi.get('book/topbooks/'+this.state.LanguageInfo[0].Code);
        //console.log(TopBooksConst.data[0].FormStatusCode==='BS_Loading');
        this.setState({
            TopBooks: TopBooksConst.data
        });

        const WordSummery = await webapi.get('pages/wordsummery');
        //console.log(WordSummery.data);
        this.setState({
            WordSummery: WordSummery.data
        });
    }

    render() {
        if (this.state.pageData && this.state.LanguageInfo) {
            return (
                <div>
                    {
                        //<Helmet htmlAttributes={{lang: this.state.LanguageInfo[0].Code}} />
                    }

                    <Header LanguageInfo = {this.state.LanguageInfo}/>

                    <div className="container-fluid" id="firstpage_row_1">
                        <div className="container">
                            <div id="columns">
                                <div className="column">
                                    <h3>
                                        <a href={"/surf?lang="+this.state.LanguageInfo[0].Code}><img alt="01" src={Parsig01} />{this.state.pageData.length!==0 && this.state.pageData[0].F10101!== undefined?this.state.pageData[0].F10101:10101}</a>
                                    </h3>
                                </div>
                                <div className="column">                                    
                                    <h3>
                                        <a href={"/search?lang="+this.state.LanguageInfo[0].Code}><img alt="01" src={Parsig04} />{this.state.pageData.length!==0 && this.state.pageData[0].F10102!== undefined?this.state.pageData[0].F10102:10102}</a>                                      
                                    </h3>
                                </div>
                                <div className="column">                                    
                                    <h3>
                                        <a href={"/tags?lang="+this.state.LanguageInfo[0].Code}><img alt="01" src={Parsig02} />{this.state.pageData.length!==0 && this.state.pageData[0].F10103!== undefined?this.state.pageData[0].F10103:10103}</a>
                                    </h3>
                                </div>
                                <div className="column">                                    
                                    <h3>
                                        <a href={"/relative?lang="+this.state.LanguageInfo[0].Code}><img alt="01" src={Parsig03} />{this.state.pageData.length!==0 && this.state.pageData[0].F10104!== undefined?this.state.pageData[0].F10104:10104}</a>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container-fluid" id="firstpage_row_2">
                        <div className="container">
                            <div id="firstpage_row_2_img">
                                <img alt="01" src={Parsig1jpg} />
                            </div>
                            <div id="firstpage_row_2_text">
                                <h4>{this.state.pageData.length!==0 && this.state.pageData[0].F10105!== undefined?this.state.pageData[0].F10105:10105}</h4>
                                <hr />
                                <p style={{textAlign:"justify"}} dangerouslySetInnerHTML={{__html:this.state.pageData.length!==0 && this.state.pageData[0].F10106!== undefined?this.state.pageData[0].F10106:10106}}></p>
                                <a href={"/aboutus?lang="+this.state.LanguageInfo[0].Code} className="btn btn-outline-primary">{this.state.pageData.length!==0 && this.state.pageData[0].F10107!== undefined?this.state.pageData[0].F10107:10107/*بیشتر بخوانید*/}</a>
                            </div>
                        </div>
                    </div>

                    <TopBooks   pageData={this.state.pageData}
                                LanguageInfo = {this.state.LanguageInfo}
                    />

                    <div className="container-fluid" id="firstpage_row_5">
                        <div className="container">
                        {
                            (this.state.WordSummery && this.state.WordSummery.length>0)
                            ?
                            <div id="columns">
                                <div className="column">
                                    <img alt="01" src={fig9} />
                                    <h6>{this.state.pageData.length!==0 && this.state.pageData[0].F10201!== undefined?this.state.pageData[0].F10201:10201/*متون بارگذاری شده*/}</h6>
                                    <p>{this.state.WordSummery[0].BookCount}</p>
                                </div>
                                <div className="column">
                                    <img alt="01" src={fig10} />
                                    <h6>{this.state.pageData.length!==0 && this.state.pageData[0].F10202!== undefined?this.state.pageData[0].F10202:10202/*واژه های بارگذاری شده*/}</h6>
                                    <p>{this.state.WordSummery[0].TextWordCount}</p>
                                </div>
                                <div className="column">
                                    <img alt="01" src={fig11} />
                                    <h6>{this.state.pageData.length!==0 && this.state.pageData[0].F10203!== undefined?this.state.pageData[0].F10203:10203/*واژه های بدون تکرار*/}</h6>
                                    <p>{this.state.WordSummery[0].WordCount}</p>
                                </div>
                                <div className="column">
                                    <img alt="01" src={fig12} />
                                    <h6>{this.state.pageData.length!==0 && this.state.pageData[0].F10204!== undefined?this.state.pageData[0].F10204:10204/*بن واژه های بارگذاری شده*/}</h6>
                                    <p>{this.state.WordSummery[0].WordRootCount}</p>
                                </div>
                            </div>
                            :
                            null
                        }
                        </div>
                    </div>

                    
                    <div className="container-fluid" id="firstpage_row_3">
                        <div className="container">
                            {/* <div id="firstpage_row_3_text">
                                <h4>حامیان پارسیگ</h4>
                                <hr />
                            </div> */}
                            {/* <div id="columns">
                            <div className="column"></div>
                                <div className="column">
                                    <a href="http://www.ashaerp.com" target="_blank" rel="noopener noreferrer"><img alt="01" src={jpeg2} /></a>
                                    </div>
                                <div className="column">
                                    <a href="http://www.ihcs.ac.ir/fa" target="_blank" rel="noopener noreferrer"><img alt="01" src={Parsigpazhouheshgahpng} /></a>
                                </div>
                                
                                <div className="column">
                                    <a href="http://www.ashaerp.com" target="_blank" rel="noopener noreferrer"><img alt="01" src={Parsigashajpeg} /></a>
                                </div>
                                <div className="column"></div>
                            </div> */}
                        </div>
                    </div>


                    <Footer  Lang = {this.state.LanguageInfo[0].Code}/>
                </div>
            );
        } else {
            return (
                <div></div>
            )
        }

    }
}

export default Home;